var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isMultiple ? 'Multi' : 'Single',_vm._b({tag:"v-component",on:{"click":_vm.click}},'v-component',_vm.bind,false))}
var staticRenderFns = []

export { render, staticRenderFns }